import { FC } from "react";
import classNames from "classnames";

import { Invoice, InvoiceShort, InvoiceStatus } from "../../types/InvoiceTypes";

import {
  CancelInvoiceAction,
  CopyInvoiceLinkAction,
  DeleteInvoiceAction,
  DownloadInvoiceAction,
  DuplicateInvoiceAction,
} from "../actions";

type Props = {
  data: Invoice | InvoiceShort;
  publicView?: boolean;
  closeDropdown?: () => void;
  onDelete?: () => void;
  popover?: boolean;
};

export const InvoiceDropdown: FC<Props> = ({
  data,
  publicView = false,
  closeDropdown,
  popover = true,
  onDelete,
}) => {
  const showDeleteAction = data?.status === InvoiceStatus.DRAFT;
  const showCancelAction = data?.status === InvoiceStatus.PENDING;
  const showDuplicateAction = data?.user_is_creator;

  return (
    <div
      className={classNames(
        popover ? "popover-dropdown-menu w-52" : "dropdown-menu"
      )}
    >
      <DownloadInvoiceAction
        className="dropdown-menu-item flex flex-row justify-between w-full"
        invoiceId={data?.id}
        label
      />

      <CopyInvoiceLinkAction
        disabled={!data?.public_id}
        invoicePublicId={data?.public_id}
        label
        className="dropdown-menu-item flex flex-row justify-between w-full"
        onCopy={closeDropdown}
      />

      {!publicView && showDuplicateAction && (
        <DuplicateInvoiceAction
          className="dropdown-menu-item flex flex-row justify-between w-full"
          invoiceId={data.id}
          label
        />
      )}

      {!publicView && showDeleteAction && (
        <DeleteInvoiceAction
          className="dropdown-menu-item flex flex-row justify-between w-full"
          invoiceId={data.id}
          label
          onDelete={onDelete}
        />
      )}

      {!publicView && showCancelAction && (
        <CancelInvoiceAction
          className="dropdown-menu-item flex flex-row justify-between w-full"
          invoiceId={data.id}
          label
        />
      )}
    </div>
  );
};
